import { createContext, useContext } from "react";

// ChatSheet pre-stages its client on the adapter side-channel
// (setNextClientId) and owns that scope for the whole open/close
// lifecycle. The composer's client selector must not render there: a
// blank selector would misrepresent the staged scope, and its
// stage/clear writes would fight the sheet's. Lives in its own module
// because thread.tsx <-> chat-sheet.tsx would otherwise be an import
// cycle.
export const ChatSheetSurfaceContext = createContext(false);

export const useIsChatSheetSurface = () => useContext(ChatSheetSurfaceContext);
